import { Card, Skeleton, Stack, useTheme } from "@mui/material";

const UserFeedbackListItemSkeleton = () => {
  const theme = useTheme();

  return (
    <Card elevation={0} sx={{ border: `solid 1px ${theme.palette.line.main}`, p: { sm: 0.5, md: 1 } }}>
      <Stack spacing={0.5}>
        <Stack direction="row" spacing={0.5} sx={{ mb: 0.5 }}>
          <Skeleton variant="rounded" width={160} height={20} />
          <Skeleton variant="rounded" width={140} height={20} />
        </Stack>
        <Stack spacing={0.25}>
          <Skeleton variant="rectangular" width={120} height={28} />
          <Skeleton variant="rectangular" width={160} height={24} />
        </Stack>
        <Stack direction="row" spacing={0.5}>
          <Skeleton variant="rectangular" width={200} height={17} />
          <Skeleton variant="rectangular" width={120} height={17} />
        </Stack>
      </Stack>
    </Card>
  );
};

export { UserFeedbackListItemSkeleton };
